/* eslint-disable */
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Injectable } from '@angular/core';
import { ApplicationActions } from '../actions/application.actions';
import { FlowManagerService } from '../shared/services/flowmanager.service';

@Injectable()
export class ReviewResolver implements Resolve {
  constructor(appActions: ApplicationActions, flowManager: FlowManagerService) {
    this.appActions = appActions;
    this.flowManager = flowManager;
    // Uncomment this to test review page without having to go through the entire app
    // May need to update if format ever changes
    // this._setState();
  }

  resolve(route:ActivatedRouteSnapshot, state:RouterStateSnapshot) {
    let reviewData = this.appActions.getData('review', {});

    for (let key in reviewData) {
      this._getFieldData(reviewData[key]);
    }

    const sections = Object.keys(reviewData);

    // make sure account type is top section
    if (sections.indexOf('/select-account-type') > 0) {
      sections.splice(sections.indexOf('/select-account-type'), 1);
      sections.unshift('/select-account-type');
    }

    // if authed no personal-info
    if (this.flowManager.isAuthed === true) {
      if (sections.indexOf('/personal-info-auth') > -1) {
        sections.splice(sections.indexOf('/personal-info-auth'), 1);
      }
    }

    return {
      reviewData,
      sections
    };
  }

  _getFieldData(fields) {
    for(let key in fields) {
      let field = fields[key];
      if (field.inputPath !== undefined) {
        field.value = this.appActions.getData(field.inputPath);
      } else if (key !== 'options' && field.value === undefined) {
        this._getFieldData(field);
      }
    }
  }

  // For used when testing
//   _setState() {
//     const data = {
//   "EmploymentInformation": {
//     "employmentStatus": "Self employed",
//     "employed": {
//       "address": {
//         "state": "NC",
//         "country": "US",
//         "street": "Emp Addy",
//         "street2": "Addy 2",
//         "city": "City",
//         "zip": "28078"
//       },
//       "natureOfBusiness": "Engineering ",
//       "employer": "Employer Name",
//       "phone": "704-456-7890",
//       "occupation": "Programmer",
//       "employedSince": "10/2016"
//     },
//     "affiliated": false,
//     "tenPercentShareholder": false,
//     "Position": "Select",
//     "politicallyAffiliated": false
//   },
//   "review": {
//     "/select-account-type": {
//       "accountType": {
//         "label": "Account Type",
//         "inputPath": "accountTypeRadio",
//         "value": "select-individual"
//       },
//       "wheel": {
//         "label": "How did you hear about us",
//         "inputPath": "ApplicationInformation.referralMethod",
//         "value": "Yahoo Finance"
//       },
//       "options": {
//         "label": "Account Type",
//         "route": "/select-account-type"
//       }
//     },
//     "/empty-info": {},
//     "/personal-info": {
//       "address_street": {
//         "label": "Address",
//         "inputPath": "PersonalInformation.address.street"
//       },
//       "address_city": {
//         "label": "City",
//         "inputPath": "PersonalInformation.address.city"
//       },
//       "address_state": {
//         "label": "State or US Territory",
//         "inputPath": "PersonalInformation.address.state"
//       },
//       "address_zip": {
//         "label": "Zip",
//         "inputPath": "PersonalInformation.address.zip"
//       },
//       "mailAddressDifferent": {
//         "label": "Different mailing address",
//         "inputPath": "PersonalInformation.mailAddressDifferent"
//       },
//       "Mailing_Address_State": {
//         "label": "State or US Territory",
//         "inputPath": "PersonalInformation.mailingAddress.state"
//       },
//       "mobilePhone": {
//         "label": "Primary Phone",
//         "inputPath": "PersonalInformation.mobilePhone"
//       },
//       "email": {
//         "label": "Email Address",
//         "value": "test1234test1234test1234test1234test1234test1234test1234test1234test1234test1234test1234test1234@gmail.com"
//       },
//       "ssn": {
//         "label": "Social Security Number",
//         "inputPath": "PersonalInformation.ssn"
//       },
//       "test": {
//         "label": "You better not be able to see me",
//         "value": ""
//       },
//       "dob": {
//         "label": "Birth Date",
//         "inputPath": "PersonalInformation.dob"
//       },
//       "citizenship": {
//         "label": "Country of Citizenship",
//         "inputPath": "PersonalInformation.address.country"
//       },
//       "maritalStatus": {
//         "label": "Marital Status",
//         "inputPath": "PersonalInformation.maritalStatus"
//       },
//       "dependents": {
//         "label": "Dependents",
//         "inputPath": "PersonalInformation.dependents"
//       },
//       "securityQuestion": {
//         "label": "Security Question",
//         "inputPath": "YourInformation.securityQuestion"
//       },
//       "securityAnswer": {
//         "label": "Security Answer",
//         "inputPath": "YourInformation.securityAnswer"
//       },
//       "options": {
//         "label": "Personal Information",
//         "route": "/personal-info"
//       }
//     },
//     "/employment-info": {
//       "employmentStatus": {
//         "label": "Employment Status",
//         "inputPath": "EmploymentInformation.employmentStatus"
//       },
//       "employed_address": {
//         "state": {
//           "label": "State or US Territory",
//           "inputPath": "EmploymentInformation.employed.address.state"
//         },
//         "country": {
//           "label": "Country",
//           "inputPath": "EmploymentInformation.employed.address.country"
//         },
//         "street": {
//           "label": "Employer Address",
//           "inputPath": "EmploymentInformation.employed.address.street"
//         },
//         "city": {
//           "label": "City",
//           "inputPath": "EmploymentInformation.employed.address.city"
//         },
//         "zip": {
//           "label": "Zip",
//           "inputPath": "EmploymentInformation.employed.address.zip"
//         }
//       },
//       "natureOfBusiness": {
//         "label": "Nature of Business",
//         "inputPath": "EmploymentInformation.employed.natureOfBusiness"
//       },
//       "affiliated": {
//         "label": "Is Affiliated",
//         "inputPath": "EmploymentInformation.affiliated"
//       },
//       "tenPercentShareholder": {
//         "label": "10% shareholder or policy-making officer",
//         "inputPath": "EmploymentInformation.tenPercentShareholder"
//       },
//       "position": {
//         "label": "Position",
//         "inputPath": "EmploymentInformation.Position"
//       },
//       "politicallyAffiliated": {
//         "label": "Politically Affiliated",
//         "inputPath": "EmploymentInformation.politicallyAffiliated"
//       },
//       "options": {
//         "label": "Employment Information",
//         "route": "/employment-info"
//       },
//       "employer": {
//         "label": "Employer",
//         "inputPath": "EmploymentInformation.employed.employer"
//       },
//       "employer_address": {
//         "street2": {
//           "label": "Address Line 2",
//           "inputPath": "EmploymentInformation.employed.address.street2"
//         }
//       },
//       "mobilePhone": {
//         "label": "Telephone",
//         "inputPath": "EmploymentInformation.employed.phone"
//       },
//       "occupation": {
//         "label": "Occupation",
//         "inputPath": "EmploymentInformation.employed.occupation"
//       },
//       "employedSince": {
//         "label": "Employed Since",
//         "inputPath": "EmploymentInformation.employed.employedSince"
//       }
//     },
//     "/financial-info": {
//       "annualIncome": {
//         "label": "Annual Income",
//         "inputPath": "FinancialInformation.annualIncome"
//       },
//       "netWorth": {
//         "label": "Net Worth",
//         "inputPath": "FinancialInformation.netWorth"
//       },
//       "liquidNetWorth": {
//         "label": "Liquid Net Worth",
//         "inputPath": "FinancialInformation.liquidNetWorth"
//       },
//       "taxBracket": {
//         "label": "Tax Bracket",
//         "inputPath": "FinancialInformation.taxBracket"
//       },
//       "FinancialInformation_Securities": {
//         "label": "Experience trading securities",
//         "inputPath": "FinancialInformation.isExperienced"
//       },
//       "stockYears": {
//         "label": "Stocks (Years)",
//         "inputPath": "FinancialInformation.stockYears"
//       },
//       "stockAnnualTrades": {
//         "label": "Stocks (Annual Trades)",
//         "inputPath": "FinancialInformation.stockAnnualTrades"
//       },
//       "stockAverageTradeSize": {
//         "label": "Stocks (Avg. Trade Size $)",
//         "inputPath": "FinancialInformation.stockAverageTradeSize"
//       },
//       "optionYears": {
//         "label": "Options (Years)",
//         "inputPath": "FinancialInformation.optionYears"
//       },
//       "optionAnnualTrades": {
//         "label": "Options (Annual Trades)",
//         "inputPath": "FinancialInformation.optionAnnualTrades"
//       },
//       "optionAverageTradeSize": {
//         "label": "Options (Avg. Trade Size $)",
//         "inputPath": "FinancialInformation.optionAverageTradeSize"
//       },
//       "options": {
//         "label": "Financial Information",
//         "route": "/financial-info"
//       }
//     },
//     "/investment-objective": {
//       "investmentObjective": {
//         "label": "Investment Objective",
//         "inputPath": "GoalInformation.investmentObjective"
//       },
//       "time_horizon": {
//         "label": "Time Horizon",
//         "inputPath": "GoalInformation.timeHorizon"
//       },
//       "liquidity_needs": {
//         "label": "Liquidity Needs",
//         "inputPath": "GoalInformation.liquidityNeeds"
//       },
//       "risk_tolerance": {
//         "label": "Risk Tolerance",
//         "inputPath": "GoalInformation.riskTolerance"
//       },
//       "applyMargins": {
//         "label": "Apply for Margin",
//         "inputPath": "GoalInformation.applyForMargin"
//       },
//       "applyOptions": {
//         "label": "Apply for Option Trading",
//         "inputPath": "GoalInformation.applyForOption"
//       },
//       "tradingLevels": {
//         "label": "Option Level",
//         "inputPath": "GoalInformation.optionLevel"
//       },
//       "options": {
//         "label": "Investment Objective",
//         "route": "/investment-objective"
//       }
//     },
//     "/edit-beneficiary-info": {
//       "options": {
//         "label": "Beneficiary Information",
//         "route": "/edit-beneficiary-info"
//       },
//       "primary0": {
//         "type": "Primary",
//         "label": "Andrew Waters",
//         "value": {
//           "relationship": {
//             "label": "Relationship",
//             "value": "Parent"
//           },
//           "firstName": {
//             "label": "First Name",
//             "value": "Andrew"
//           },
//           "lastName": {
//             "label": "Last Name",
//             "value": "Waters"
//           },
//           "address": {
//             "street": {
//               "label": "Mailing Address",
//               "value": "12345 Not a Real Street"
//             },
//             "street2": {
//               "label": "Address Line 2"
//             },
//             "city": {
//               "label": "City",
//               "value": "Charlotte"
//             },
//             "state": {
//               "label": "State or US Territory",
//               "value": "North Carolina"
//             },
//             "zip": {
//               "label": "Zip",
//               "value": "28277"
//             }
//           },
//           "ssn": {
//             "label": "Social Security Number",
//             "value": "123-12-1234"
//           },
//           "dob": {
//             "label": "Birth Date",
//             "value": "11/22/1988"
//           },
//           "email": {
//             "label": "Email Address",
//             "value": "test1234test1234test1234test1234test1234test1234test1234test1234test1234test1234test1234test1234@gmail.com"
//           },
//           "percent": {
//             "label": "Funds Allocated",
//             "value": "100%"
//           }
//         }
//       },
//       "primary1": {
//         "type": "Primary",
//         "label": "WHYWOULDANYONEHAVEANAMETHISLONGORWITHSOMANYWORDS.THISISALIE.THECAKEISALIE!",
//         "value": {
//           "relationship": {
//             "label": "Relationship",
//             "value": "Children"
//           },
//           "firstName": {
//             "label": "First Name",
//             "value": "Someone"
//           },
//           "lastName": {
//             "label": "Last Name",
//             "value": "Else"
//           },
//           "address": {
//             "street": {
//               "label": "Mailing Address",
//               "value": "Minimal Address Line 1"
//             },
//             "street2": {
//               "label": "Address Line 2"
//             },
//             "city": {
//               "label": "City",
//               "value": "Charlotte"
//             },
//             "state": {
//               "label": "State or US Territory",
//               "value": "North Carolina"
//             },
//             "zip": {
//               "label": "Zip",
//               "value": "28277"
//             }
//           },
//           "ssn": {
//             "label": "Social Security Number",
//             "value": "125-12-5122"
//           },
//           "dob": {
//             "label": "Birth Date",
//             "value": "10/10/1999"
//           },
//           "email": {
//             "label": "Email Address"
//           },
//           "percent": {
//             "label": "Funds Allocated",
//             // "inputPath": "BeneficiaryInformation.Primary[1].percent" (doesnt work yet)
//             "value": "100%"
//           }
//         }
//       }
//     }
//   },
//   "appState": {
//     "showVal": {
//       "employmentStatus_Show": true
//     },
//     "radioClick": {},
//     "financialRadioClick": {},
//     "optionTradingl1": true,
//     "optionTradingl12": true,
//     "optionTradingl16": true,
//     "optionTradingl13": true,
//     "IRARadio": true,
//     "showAll": true,
//     "promoShow": false,
//     "helperShow": true
//   },
//   "FinancialInformation": {
//     "annualIncome": "$25,001-$50,000",
//     "netWorth": "$25,001-$50,000",
//     "liquidNetWorth": "$25,001-$50,000",
//     "taxBracket": "15%-30%",
//     "isExperienced": false,
//     "stockYears": "Select",
//     "stockAnnualTrades": "Select",
//     "stockAverageTradeSize": "Select",
//     "optionYears": "Select",
//     "optionAnnualTrades": "Select",
//     "optionAverageTradeSize": "Select"
//   },
//   "GoalInformation": {
//     "investmentObjective": "individual_account_type",
//     "timeHorizon": "Longest (8 years or more)",
//     "liquidityNeeds": "Not important",
//     "riskTolerance": "High",
//     "applyForMargin": false,
//     "applyForOption": false,
//     "optionLevel": null
//   },
//   "YourInformation": {
//     "firstName": "Andrew",
//     "lastName": "Waters",
//     "email": "awaters@tradeking.com",
//     "confirmEmail": "awaters@tradeking.com",
//     "securityQuestion": "Mother's maiden name?",
//     "securityAnswer": "Bradford"
//   },
//   "ApplicationInformation": {
//     "accountType": "select-individual",
//     "referralMethod": "Yahoo Finance"
//   },
//   "accountTypeRadio": "select-individual",
//   "PersonalInformation": {
//     "address": {
//       "street": "12345 Not a Real Street",
//       "city": "Charlotte",
//       "state": "SC",
//       "zip": "28277",
//       "country": "US"
//     },
//     "mailAddressDifferent": false,
//     "mailingAddress": {
//       "state": "Select"
//     },
//     "mobilePhone": "704-123-1234",
//     "ssn": "123-12-1234",
//     "dob": "11/22/1988",
//     "maritalStatus": "Single",
//     "dependents": "1"
//   },
//   "BeneficiaryInformation": {
//     "Primary": [{
//       "relationship": "Parent",
//       "firstName": "Andrew",
//       "lastName": "Waters",
//       "address": {
//         "street": "12345 Not a Real Street",
//         "city": "Charlotte",
//         "state": "North Carolina",
//         "zip": "28277"
//       },
//       "ssn": "123-12-1234",
//       "dob": "11/22/1988",
//       "percent": "100",
//       "editable": true,
//       "type": "P"
//     }, {
//       "relationship": "Children",
//       "firstName": "Someone",
//       "lastName": "Else",
//       "address": {
//         "street": "Minimal Address Line 1",
//         "city": "Charlotte",
//         "state": "North Carolina",
//         "zip": "28277"
//       },
//       "ssn": "125-12-5122",
//       "dob": "10/10/1999",
//       "percent": "100",
//       "editable": true,
//       "type": "P"
//     }],
//     "Temp": [{
//       "relationship": "Children",
//       "firstName": "Someone",
//       "lastName": "Else",
//       "address": {
//         "street": "Minimal Address Line 1",
//         "city": "Charlotte",
//         "state": "North Carolina",
//         "zip": "28277"
//       },
//       "ssn": "125-12-5122",
//       "dob": "10/10/1999",
//       "percent": "100"
//     }]
//   }
// };

//   const keys = Object.keys(data);
//   for (let i in keys) {
//     const key = keys[i];
//     this.appActions.setData(key, data[key]);
//   }
// }
}
